import { privateRequest } from "../axios";
import type { ApiResponse, ListApiResponse } from "@/types/common";
import type { EventType } from "./events";

export interface MembershipGrowthPoint {
  month: string;
  year: number;
  newMemberCount: number;
}

export interface DashboardSummary {
  activeMemberCount: number;
  pendingApplicationCount: number;
  annualRecurringRevenue: {
    year: number;
    amount: number;
  };
  membershipGrowth: {
    period: number;
    data: MembershipGrowthPoint[];
  };
  applicationFunnel: {
    activeUser: number;
    blockedUser: number;
    underReviewUser: number;
    totalUser: number;
    rejectedUser?: number;
  };
}

export interface GetDashboardSummaryParams {
  revenueYear: number;
  growthPeriod: number;
}

export interface GetUpcomingEventsParams {
  pageNo?: number;
  perPage?: number;
}

export interface UpcomingEvent {
  name: string;
  type: EventType;
  cities: string[];
  date: string;
  capacity: number;
  eventPublishingStatus: string | null;
}

const ENDPOINTS = {
  SUMMARY: "/dashboard/summary",
  UPCOMING_EVENTS: "/dashboard/upcoming-events",
};

const getDashboardSummary = async (params: GetDashboardSummaryParams) => {
  const response = await privateRequest.get<ApiResponse<DashboardSummary>>(ENDPOINTS.SUMMARY, { params });
  return response.data;
};

const getUpcomingEvents = async (params?: GetUpcomingEventsParams) => {
  const response = await privateRequest.get<ListApiResponse<UpcomingEvent>>(ENDPOINTS.UPCOMING_EVENTS, { params });
  return response.data;
};

const dashboardService = {
  getDashboardSummary,
  getUpcomingEvents,
};

export default dashboardService;
